import { forwardRef } from 'react';
import { Reset as RadixReset } from '@radix-ui/themes';
import type { RadixResetProps } from '@/types/radix-ui';

/**
 * Reset component - wrapper around Radix UI Reset
 * Provides CSS reset utilities for specific elements
 */
export type ResetProps = RadixResetProps;

const Reset = forwardRef<HTMLElement, ResetProps>((props, ref) => {
  return <RadixReset ref={ref} {...props} />;
});

Reset.displayName = 'Reset';

export { Reset };
